import {Presenter} from '../../support/with_presenter';
import {ExpandedPart, ExpandedPartsProvider} from '../../business/expanded_parts/ExpandedPartsProvider';
import {Subscription} from 'rxjs';
import {MediaProvider} from '../../business/media/MediaProvider';
import {Media} from '../../models/Media';

export class MediaPresenter implements Presenter {
    public loading = true;
    public error = false;
    public media: Media[] = [];

    public expandedParts: ExpandedPart[] = [];

    private subscription: Subscription | undefined;

    constructor(private expandedPartsProvider: ExpandedPartsProvider, private mediaProvider: MediaProvider) {}

    public mount(): void {
        this.subscription = this.expandedPartsProvider.expandedParts.subscribe(
            (expandedParts) => (this.expandedParts = expandedParts),
        );

        this.mediaProvider.get().then(
            (media) => {
                this.loading = false;
                this.media = media;
            },
            (error) => {
                this.loading = false;
                this.error = true;
            },
        );
    }

    public unmount(): void {
        this.subscription?.unsubscribe();
    }
}
